<template>
  <main>
    <Confirm />
    <FooterShout :type="'register'"/>
  </main>
</template>

<script>
  import Confirm from '../components/Confirm'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      Confirm,
      FooterShout
    }
  }
</script>
